import { UntypedFormGroup, Validators } from '@angular/forms';
import { patternValidator } from 'src/app/utils/pattern-validator';
import { RegistrationFields } from 'src/app/services/signup/registration.models';
import { HttpErrorResponse } from '@angular/common/http';
import { safeEmailValidator } from 'src/app/utils/email-validator';

export function applyServerValidators(resp: RegistrationFields, form: UntypedFormGroup) {
  Object.keys(resp.fields).forEach(name => {
    let validators = []
    const formControl = form.get(name);
    if (!formControl) return;
    const values = resp.fields[name];

    if (values.max_length) {
      validators.push(Validators.maxLength(values['max_length']));
    }
    if (values.min_length) {
      validators.push(Validators.minLength(values['min_length']));
    }
    if (values.required) {
      validators.push(Validators.required);
    }

    if (name === 'email') {
      validators.push(safeEmailValidator());
    }
    if (values.widget && values.widget.attrs && values.widget.attrs.patterns) {

      values.widget.attrs.patterns.forEach((pattern) => {
        Object.keys(pattern).forEach(prop => {
          if (prop !== "ignore_case" && prop !== "regex_negative") {
            validators.push(patternValidator(new RegExp(pattern[prop]), values.error_messages[prop], pattern.regex_negative));
          }
        })
      })
    }
    formControl.setValidators(validators);
  });
  form.get('current_step').setValue(resp.current);
}

export function applyServerErrors(error: HttpErrorResponse, form: UntypedFormGroup) {
  let isHasServerErrors: boolean = false;
  if (error.error.errors === undefined) return isHasServerErrors;
  Object.keys(error.error.errors).forEach(prop => {
    isHasServerErrors = true;
    const formControl = form.get(prop);
    if (formControl) {
      // activate the error message
      const errorMsg = error.error.errors[prop]?.constructor === Array ? error.error.errors[prop][0] : error.error.errors[prop]
      formControl.setErrors({
        serverError: errorMsg
      });
    }
  });
  return isHasServerErrors;
}
